// Keep actions in the step's scroll content so they follow the last field.
export default function EventCreateFloatingFooter({ children }) {
  return children;
}
